export const itemsLinks = [
  {
    name: 'Credit Cards',
    url: '/l/awards-credit-cards-2023',
  },
  {
    name: 'Banking',
    url: '/l/awards-banking-2023',
  },
  {
    name: 'Personal Loans',
    url: '/l/awards-personal-loans-2023',
  },
  {
    name: 'Mortgages',
    url: '/l/awards-mortgages-2023',
  },
  {
    name: 'Investing',
    url: '/l/awards-investing-2023',
  },
  {
    name: 'Student Loans',
    url: '/l/awards-student-loans-2023',
  },
  {
    name: 'Insurance',
    url: '/l/awards-insurance-2023',
  },
  {
    name: 'Travel',
    url: '/l/awards-travel-2023',
  },
];

export const logoLink = {
  name: 'Home',
  url: '/l/awards',
};
